import { IconLib } from 'components/Atoms/IconLib'
import styled, { css } from 'styled-components'

const designerCSS = css`
  .overlay div.table-wrapper {
    position: relative;
    height: 100%;
    overflow: hidden auto;
    margin: 30px;
    max-height: calc(100% - 60px);
  }

  div.table-wrapper::-webkit-scrollbar {
    width: 0px;
  }

  .overlay div.table-body {
    position: relative;
    display: grid;
    grid-template-columns: ${({ gridColumns }) => gridColumns};
    grid-template-rows: auto;
    font-size: 1.1rem;
    font-weight: 600;
    /* border-radius: 10px; */
    overflow: hidden;
  }
  div.table-cell-header {
    padding: 10px;
    font-size: 0.8rem;
    background: var(--transparent_table-header-background);
  }
  div.table-cell-data {
    padding: 10px;
    font-size: 0.8rem;
    background: none;
    border-bottom: 1px solid var(--transparent_table-data-border-color);
  }
  div.table-cell-data:nth-last-child(-n + 3) {
    border-bottom: 0;
  }
`

const developerCSS = css``

export const HiLoStatsCSS = styled.div`
  ${designerCSS}
  ${developerCSS}
`
export const Close = styled(IconLib).attrs({ collection: 'general', name: 'closeOutline', dimension: '25px' })`
  position: absolute;
  left: 10px;
  top: 10px;
  background: rgb(255, 255, 255);
  z-index: 1;

  :hover {
    cursor: pointer;
  }
`
